export const loginUrls = [{city: "Lamar", loginUrl: "lamarmosynkrous"},
{city: "Hamshire", loginUrl: "hamshiretxsynkrous"},
{city: "Kermit", loginUrl: "kermittxsynkrous"},
{city: "Wink", loginUrl: "kermittxsynkrous"},
{city: "Paris", loginUrl: "lamarwireless-synkro"},
{city: "Colville", loginUrl: "adept4u"}
]